const BASE_URL_ADMIN = import.meta.env.EDS_BASE_URL_ADMIN;
const BASE_URL_V3_USER = import.meta.env.EDS_BASE_URL_V3_USER;
const BASE_URL_V1_USER = import.meta.env.EDS_BASE_URL;
const EDS_SERVER_BASE_URL_V2 = import.meta.env.EDS_SERVER_BASE_URL_V2;

const API_ENDPOINTS = {
  USERS_ME: "/me",
  USERS_LOGIN: "/login",
  USERS_UPDATE_TIMEZONE: `${BASE_URL_V3_USER}/timezone`,
  USERS_REGISTRATION: (token: string) => `/registration/${token}`,
  USERS_FORGOT_PASSWORD: "/forgot-password",
  USERS_FORGOT_PASSWORD_BETA: "/forgot-password",
  USERS_PASSWORD_TOKEN_VERIFICATION: (token: string) =>
    `/verify-token/${token}`,
  FIND_USER: (token: string) => `/find/${token}`,
  USERS_RESET_PASSWORD: "/reset-password",
  USERS_RESET_PASSWORD_BETA: "/reset-password",
  USERS_NEW_PASSWORD: (token: string) => `/v1/${token}/update`,
  USERS_LOGOUT: "/logout",
  NOTIFICATIONS: "/notifications",
  NOTIFICATIONS_SET_SEEN: "/notifications/set-seen",
  EVENTS_AND_MATERIALS: "/events-and-materials",
  USER_EXERCISES: "/exercises",
  USER_EXERCISES_POT: "/exercises/pot",
  USER_LOGIN_ACTIVITY: (token: string) => `/login-activity/${token}`,
  BOOKED_IELTS: "/booked-ielts",
  BOOK_IELTS: "/book-ielts",
  UPLOAD_PIC_BOOK_IELTS: "/upload-pic-book-ielts",
  REMOVE_BOOK_IELTS: (id: number) => `/book-ielts/${id}`,
  AVAILABILITIES: "/availabilities",
  PAYMENTS: "/payments",
  USER_PRODUCTS: "/products",
  USER_SAVE_ONBOARDING: "/onboarding",
  DELETE_EVENT: (id: number) =>
    EDS_SERVER_BASE_URL_V2 + `/users/remove-event/${id}`,
  UPSELLING_TRACK: EDS_SERVER_BASE_URL_V2 + `/users/tracks`,
  GET_USER_REFERRALS: "/referrals",
  DOWNLOAD_INVOICE: BASE_URL_ADMIN + "/v1/users/download/invoice",
  CALENDAR_LIST: BASE_URL_ADMIN + "/v1/calendar-list",
  SET_RECORDING: (id: number) =>
    `${BASE_URL_ADMIN}/v1/set/event-recording/${id}`,
  BOOK_DIPLOMA_REQUEST: BASE_URL_ADMIN + "/v1/calendar-events/create",
  AVAILABILITIES_TUTOR:
    BASE_URL_V1_USER + "/v1/booking-correction/availabilities/get",
  AVAILABILITIES_TUTOR_ONE_TO_ONE: "/tutor-availabilities",
  AVAILABILITIES_TUTOR_ALL: "/tutor-availabilities-all",
  // SPEAKING_CLASS_TUTOR_AND_TOPIC_LIST: "/speaking-class",
  SPEAKING_CLASS_TUTOR_AND_TOPIC_LIST: "/events/get/speaking-classes",
  SPEAKING_CLASS_TUTOR_SCHEDULE: "/events/schedule/speaking-classes",
  // BOOK_ONE_TO_ONE: BASE_URL_V1_USER + "/v1/one-to-one/create",
  BOOK_ONE_TO_ONE: "/one-to-one",
  ONE_TO_ONE_TOPICS_DONE: "/one-to-one/topics-done",
  // BOOK_MOCK_TEST: BASE_URL_V1_USER + "/v1/book-mock-test/create",
  BOOK_MOCK_TEST: "/mock-test",
  // BOOK_LIVE_CORRECTION: BASE_URL_V1_USER + "/v1/booking-correction/create",
  CHECK_BOOK_LIVE_CORRECTION: "/check-book-correction",
  BOOK_LIVE_CORRECTION: "/book-correction",
  CORRECT_EXERCISE: (id: number) =>
    BASE_URL_V1_USER + "/v1/correct-exercise/" + id,
  GET_CHANGED_EVENTS: BASE_URL_V1_USER + "/v2/change-event/get-by-user",
  GET_CHANGE_EVENT: BASE_URL_V1_USER + "/v2/change-event/get",
  SET_CHANGED_EVENTS: BASE_URL_V1_USER + "/v2/change-event/set",
  FEEDBACK_RATINGS: BASE_URL_V1_USER + "/v1/nps-feedback/set",
  CREATE_FEEDBACK: BASE_URL_V1_USER + "/v1/feedback/create",
  GET_RECORDING: (id: number) => BASE_URL_V1_USER + "/v1/event-recording/" + id,
  UPDATE_USER_AVAILABILITY: BASE_URL_V1_USER + "/v1/availability/updateA",
  GET_FILE: (id: number | string) => BASE_URL_V1_USER + "/v1/get-file/" + id,
  ONE_TO_ONE_CREDITS: "/one-to-one-credits",
  CLASS_REPORTS: "/class-reports",
  USER_REPORTS: "/v1/reports/get",
  GENERATE_I_FRAME_SPEECHACE:
    EDS_SERVER_BASE_URL_V2 + "/speechace/generateIFrame",
  GET_USER_SCORE_SPEECHACE: EDS_SERVER_BASE_URL_V2 + "/speechace/getUserScore",
  EXERCISE_STATUS: "/exercises/status",
  EXERCISE_SAVE: "/exercises/save",
};

export default API_ENDPOINTS;
